import React from 'react';
import {
  Filter,
  SelectInput,
  TextInput,
} from 'react-admin';
import { HOST_TYPES } from '../../constants';

const HostsFilter = (props) => {
  return (
    <Filter {...props}>
      <TextInput label="Search" source="q" alwaysOn />
      <TextInput label="Host Name" source="name" allowEmpty />
      <SelectInput source="type" choices={HOST_TYPES} />
    </Filter>
  );
};
export default HostsFilter;
